// extracted by mini-css-extract-plugin
export default {"Vcard":"VirtualAccount_Vcard__XeuM8","VAcctTxt":"VirtualAccount_VAcctTxt__hDZgV","VFundTxt":"VirtualAccount_VFundTxt__ENtOj","VBank":"VirtualAccount_VBank__o67BJ"};